import { render } from "./OverlayLoader.vue?vue&type=template&id=18e2c3e6"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__